import { render, staticRenderFns } from "./productApp.vue?vue&type=template&id=346f3192&"
import script from "./productApp.vue?vue&type=script&lang=js&"
export * from "./productApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports